export default "__VITE_ASSET__ogpS0e$gcQpyhs$Ta8AR7A__"